module.exports = __webpack_public_path__ + "./images/1b0079bd6118757625cc1827f1c79bda.webp";